<template>
  <div class="pt-mode-switcher">
    <r-radio-group :button-list="modes" :active="mode" @change="changeMode" />
  </div>
</template>

<script>
import variables from "@/styles/variables.scss";

const modes = [
  { id: "stop_points", label: "Остановки" },
  { id: "line_routes", label: "Маршруты" }
];

export default {
  props: ["state", "mode"],
  data() {
    return {
      primaryColor: variables.primaryColor,
      modes
    };
  },
  computed: {
    layersLoading() {
      return this.$store.state.publicTransport.loadingLayers.length > 0;
    }
  },
  methods: {
    changeMode(mode) {
      this.$emit("change-mode", mode);
    }
  }
};
</script>

<style lang="scss">
.pt-mode-switcher {
  background-color: var(--bg_panel_secondary) !important;
}
</style>
